module.exports = __webpack_public_path__ + "static/media/bdjobs-app-old-badge.0ddcbc52.svg";